import { Injectable } from '@angular/core';
import { LSkeys } from '../../configs/app.constants';

@Injectable({
  providedIn: 'root'
})
export class LstorageService {

  constructor() {
    if (window && !window.localStorage) {
      // console.error("Browser does not support localstorage")
    }
  }

  store(key: string, data: string) {
    localStorage.setItem(key, data);
  }

  remove(key: string) {
    localStorage.removeItem(key);
  }

  getItem(key: string) {
    return localStorage.getItem(key);
  }

  clear() {
    const languageId = localStorage.getItem(LSkeys.LANGUAGE_ID);
    localStorage.clear();
    if (languageId) {
      localStorage.setItem('languageId', languageId);
    }
  }
}
